<template>
  <vee-object :title="model.nickname" :enable.sync="model.isUsed" :expand.sync="model.isExpand" :showTitle="showTitle">
    <json-editor v-model="model.value"></json-editor>
  </vee-object>
</template>
<script>
import JsonEditor from '../components/JsonEditor'
import VeeObject from '../components/VeeObject'

export default {
  components: {
    JsonEditor,
    VeeObject
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  }
}
</script>
<style lang="scss">
</style>
